import * as React from 'react';
import SvgIcon from "../svg-icon/SvgIcon";

export const OutlineSuccessIcon = (props) => {
    return (
        <SvgIcon {...props}  viewBox="0 0 60 60" fontSize="xxLarge">
          <g id="Group_3408" data-name="Group 3408" transform="translate(-547 -160)">
            <g id="Ellipse_42" data-name="Ellipse 42" transform="translate(547 160)" fill="none" stroke="#06993c" strokeWidth="2">
              <circle cx="30" cy="30" r="30" stroke="none"/>
              <circle cx="30" cy="30" r="29" fill="none"/>
            </g>
            <path id="Path_654" data-name="Path 654" d="M341,17.734l7.156,7.156L366.047,7" transform="translate(224.018 173.72)" fill="none" stroke="#06993c" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"/>
          </g>
        </SvgIcon>
    );
};

export default OutlineSuccessIcon;
